import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
    AlphaBatchEntityObjectBaseComponent
} from "../../component/object-components/alpha-batch-entity-object-base-component/alpha-batch-entity-object-base.component";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
    providedIn: 'root'
})
export class IntegrationAlphaBatchEntityService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ha/integrationAlphaBatchEntitys')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return AlphaBatchEntityObjectBaseComponent;
        }
        return null;
    }
}